export const applyTypeTypes = {
  GET_APPLY_TYPE_LIST: "GET_APPLY_TYPE_LIST",
};